import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import { BaseLeadPage, CarleadHIWWhyChooseWkdaFaq, CarleadStep1CustomerPopup, } from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStep1CustomerPopup}
      content={CarleadHIWWhyChooseWkdaFaq}
      showCounterHeadline={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
